import React from 'react'
import intl from 'react-intl-universal'
import Link from '../../link'
import NewsCard from './card'
import { useMedia } from '../../../hooks'
import { NewsWrapper, More, NewsContainer } from './atoms'

const HotNews = ({ data }) => {
  const isMobile = useMedia()
  let showCount = isMobile ? 2 : 4
  return (
    <NewsContainer>
      <NewsWrapper>
        {data.slice(0, showCount).map(({ node }, index) => (
          <NewsCard
            key={index}
            slug={node.slug}
            title={node.title}
            date={node.legacyDate || node.createdAt}
            content={
              node.content && node.content.content
                ? node.content.content
                : node.tinyContent && node.tinyContent.tinyContent
            }
          />
        ))}
      </NewsWrapper>
      <More>
        <Link to='/news/' isInternal={false}>
          {intl.get('home.news.more')}
        </Link>
      </More>
    </NewsContainer>
  )
}
export default HotNews
